export default __webpack_public_path__ + "static/media/ParkPlus.670d7da9.png";